import { getDefaultStartDate } from "./helper";

export type ActiveFilters = {
  sortBy: boolean;
  signDate: boolean;
  exclusivity: boolean;
  listingPrice: boolean;
  listingState: boolean;
  listingCreation: boolean;
  withPriceUpdates: boolean;
  addressAreaNickname: boolean;
};

export type DateRangeFilter = {
  min: string;
  max: string;
};

export type PriceRangeFilter = {
  min: number;
  max: number;
};

export const initialActiveFilters: ActiveFilters = {
  sortBy: false,
  signDate: false,
  exclusivity: false,
  listingState: false,
  listingPrice: false,
  listingCreation: false,
  withPriceUpdates: false,
  addressAreaNickname: false
};

export const initialDateRangeFilter: DateRangeFilter = {
  min: "",
  max: ""
};

export const initialPriceRangeFilter: PriceRangeFilter = {
  min: null,
  max: null
};

export function setInitialExclusivity(): DateRangeFilter {
  return {
    ...initialDateRangeFilter,
    min: getDefaultStartDate()
  };
}
